import { Typography } from 'src/v2/components/atoms'
import { Paper } from 'src/v2/components/atoms/paper'
import styled from 'styled-components'

export const Container = styled(Paper)`
  && {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 80px;
    margin-bottom: 8px;
  }
`

export const HiddenButton = styled.input`
  && {
    display: none;
  }
`

export const Title = styled(Typography)`
  && {
    font-family: Roboto;
    font-size: ${props => props.theme.v2.typography.fontSize.large};
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    color: ${props => props.theme.v2.palette.grayScale['80']};
  }
`

export const Subtitle = styled(Typography)`
  && {
    font-family: Roboto;
    font-size: ${props => props.theme.v2.typography.fontSize.medium};
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    color: ${props => props.theme.v2.palette.grayScale['80']};
  }
`

export const Info = styled(Typography)`
  && {
    font-size: ${props => props.theme.v2.typography.fontSize.medium};
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: center;
    text-justify: center;
    color: ${props => props.theme.v2.palette.grayScale['40']};
    margin-top: 30px;
    margin-bottom: 30px;
  }
`
